export default __webpack_public_path__ + "static/media/18.1d5292e2.webp";